//export const ENDPOINT_CLASIFIYER = "http://194.163.136.163:4005"
export const ENDPOINT_CLASIFIYER = "https://productdet.deepgaze.xyz"
// export const ENDPOINT_NODE = "http://localhost:5000"

//entorno server 
export const ENDPOINT_NODE = "https://suitend.deepgaze.xyz"
//export const ENDPOINT_NODE = "http://localhost:5000"
// export const ENDPOINT_NODE = "http://62.146.179.247:5000/"